export interface DeveloperKey {
 apiKeyId: number; keyName: string; keyPrefix: string;
 permissions?: string[] | null; createdAt: string; expiresAt?: string | null;
 lastUsedAt?: string | null; usageCount?: number; status: string;
}
export class ApiError extends Error {
 constructor(message: string, public status: number) {super(message);}
}
export function deviceId() {
 if (typeof window === "undefined") return "";
 const shared = document.cookie.split("; ").find(c=>c.startsWith("seexr_device_id="))?.split("=")[1];
 if(shared) return decodeURIComponent(shared);
 let id = sessionStorage.getItem("seexr_developer_device_id");
 if (!id) { id = crypto.randomUUID(); sessionStorage.setItem("seexr_developer_device_id",id); }
 return id;
}
export async function requestCore<T>(path: string, init: RequestInit = {}, retry = true): Promise<T> {
 const headers = new Headers(init.headers);
 headers.set("Accept","application/json");
 const id = deviceId(); if(id) headers.set("X-SEEXR-Device-ID",id);
 if(init.body) headers.set("Content-Type","application/json");
 let res: Response;
 try {
   res = await fetch("/api/core/"+path.replace(/^\/+/,""),{...init,headers,credentials:"same-origin",cache:"no-store"});
 } catch { throw new ApiError("Core API에 연결하지 못했습니다.",0); }
 if (res.status===401 && retry && !path.startsWith("auth/") && path!=="api-keys/verify") {
   const refreshed=await fetch("/api/core/auth/refresh",{method:"POST",headers:{"X-SEEXR-Device-ID":id,"Content-Type":"application/json"},body:"{}",credentials:"same-origin"}).catch(()=>null);
   if(refreshed?.ok)return requestCore<T>(path,init,false);
 }
 const data: unknown=await res.json().catch(()=>null);
 const packet = data && typeof data==="object" ? data as Record<string,unknown> : {};
 if(!res.ok || packet.success===false){
   const error=packet.error && typeof packet.error==="object" ? (packet.error as Record<string,unknown>).message : packet.message;
   throw new ApiError(typeof error==="string"?error:"요청이 실패했습니다. HTTP "+res.status,res.status);
 }
 return (packet.data!==undefined?packet.data:data) as T;
}
